import { combineReducers } from "redux";
import locationReducer from "./location";
import authReducer from "./Auth";
import userReducer from "./user";
// import debit from "./debitStats";
// import credit from "./creditStats";
import branchCreditStatsReducer from "./branchCreditStats";
import branchDebitStatsReducer from "./branchDebitStats";
import headOfficeCreditStatsReducer from "./headOfficeCreditStats";
import headOfficeDebitStatsReducer from "./headOfficeDebitStats";
export default combineReducers({
  location: locationReducer,
  auth: authReducer,
  users: userReducer,
  branchCreditStats: branchCreditStatsReducer,
  branchDebitStats: branchDebitStatsReducer,
  headOfficeCreditStats: headOfficeCreditStatsReducer,
  headOfficeDebitStats: headOfficeDebitStatsReducer,
  // debit_stats: debit,
  // credit_stats: credit,
});
